import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _div;
import { lazy, Suspense } from "react";
import { Dialog, Loader } from "@crehana/ui";
import { jsx as _jsx } from "react/jsx-runtime";
var CoursePreview = /*#__PURE__*/lazy(function () {
  return import(/* webpackChunkName: "course-preview" */"./CoursePreview");
});
var LazyCoursePreview = function LazyCoursePreview(props) {
  return /*#__PURE__*/_jsx(Suspense, {
    fallback: /*#__PURE__*/_jsx(Dialog, {
      open: true,
      onDismiss: props.onDismiss,
      size: "s",
      isDark: props.isDark,
      hideCloseBtn: true,
      children: /*#__PURE__*/_jsx("div", {
        className: "relative w-full bg-black",
        style: {
          paddingTop: '56.25%'
        },
        children: _div || (_div = /*#__PURE__*/_jsx("div", {
          className: "absolute inset-0 flex items-center justify-center",
          children: /*#__PURE__*/_jsx(Loader, {
            isWhite: true
          })
        }))
      })
    }),
    children: /*#__PURE__*/_jsx(CoursePreview, _objectSpread({}, props))
  });
};
export default LazyCoursePreview;